import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  useMediaQuery,
  DialogTitle,
  Hidden,
  Toolbar,
  AppBar,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import TooltipIconButton from './TooltipIconButton';
import { seedDetailDialogIcons } from '../icon/seed-icons';

const useStyles = makeStyles((theme) => ({
  appbar: {
    backgroundColor: theme.palette.background.appBar,
  },
  onAppbar: {
    color: theme.palette.common.white,
  },
  toolbarMixin: theme.mixins.toolbar,
  toolbar: {
    paddingLeft: 0,
  },
  backButton: {
    marginRight: theme.spacing(2),
    color: theme.palette.common.white,
  },
}));

const DetailDialog = (props) => {
  const {
    open,
    onClose,
    children,
    titleId,
    disableBackdropClick,
    icons,
  } = props;
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      fullScreen={isMobile}
      fullWidth
      scroll={isMobile ? 'paper' : 'body'}
      maxWidth="md"
      disableBackdropClick={disableBackdropClick}
      open={open}
      onClose={onClose}
    >
      {
          isMobile ? (
            <AppBar className={classes.appbar}>
              <Toolbar className={classes.toolbar}>
                <TooltipIconButton
                  className={classes.backButton}
                  disabled={disableBackdropClick}
                  title="Back"
                  icon={<icons.ArrowBack />}
                  onClick={onClose}
                />
                <Typography variant="h6" className={classes.onAppbar}>
                  <FormattedMessage id={titleId} />
                </Typography>
              </Toolbar>
            </AppBar>
          ) : (
            <DialogTitle>
              <FormattedMessage id={titleId} />
            </DialogTitle>
          )
        }
      <DialogContent>
        <Hidden smUp implementation="css">
          <div className={classes.toolbarMixin} />
        </Hidden>
        {children}
      </DialogContent>
      <Hidden xsDown implementation="css">
        <DialogActions>
          <Button onClick={onClose} color="primary" disabled={disableBackdropClick}>
            <FormattedMessage id="seed.button.close" />
          </Button>
        </DialogActions>
      </Hidden>
    </Dialog>
  );
};

DetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  titleId: PropTypes.string.isRequired,

  disableBackdropClick: PropTypes.bool,
  icons: PropTypes.shape({
    ArrowBack: PropTypes.object.isRequired,
  }),
};

DetailDialog.defaultProps = {
  disableBackdropClick: false,
  icons: seedDetailDialogIcons,
};

export default DetailDialog;
